import type { FormInstance } from '@arco-design/web-react/es/Form';

import { buildImageItemFromInferenceSystem, parseInferenceFrameworkImageItem } from './presetInferenceImage';

/** 编辑/详情回显：用本地字段回填镜像卡片，不请求镜像列表 */
export function syncBuiltinInferenceImageEchoFields(
  form: FormInstance,
  systemField: string,
  system: Record<string, unknown>,
  inferenceFrameworkImageRaw: unknown,
) {
  const currentKey = String(form.getFieldValue(`${systemField}.imageKey`) ?? '').trim();
  const currentName = String(form.getFieldValue(`${systemField}.imageName`) ?? '').trim();
  if (currentKey && currentName) return;

  const catalogItem = parseInferenceFrameworkImageItem(inferenceFrameworkImageRaw);
  const fallbackItem = catalogItem || buildImageItemFromInferenceSystem(system);
  if (!fallbackItem) return;

  const nextKey = currentKey || String(fallbackItem.id ?? fallbackItem.key ?? '').trim();
  const nextName = currentName || String(fallbackItem.name ?? '').trim();
  if (!nextKey && !nextName) return;

  form.setFieldsValue({
    ...(nextKey && !currentKey ? { [`${systemField}.imageKey`]: nextKey } : {}),
    ...(nextName && !currentName ? { [`${systemField}.imageName`]: nextName } : {}),
  });
}
